import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';
import classnames from 'classnames';

export default function ModalWindow({ isVisible, content }) {
  const ref = useRef();
  useEffect(() => {
    if (isVisible) {
      document.querySelector('body').style.overflow = 'hidden';
      ref.current.scrollIntoView();
    } else {
      document.querySelector('body').style.overflow = 'auto';
    }
  }, [isVisible]);

  const modalClasses = classnames(styles.container);

  return (
    isVisible && (
      <div className={`${modalClasses} boo`}>
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div ref={ref} className={`${styles.content} p-2p0 m-auto w-100`}>
            {content}
          </div>
        </div>
      </div>
    )
  );
}

ModalWindow.propTypes = {
  description: PropTypes.any,
  isVisible: PropTypes.any,
  onClose: PropTypes.any,
  title: PropTypes.any,
  content: PropTypes.any,
};
